var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"text-decoration-none",attrs:{"to":`/${_vm.page}`,"color":"primary","x-large":"","text":""}},[_c('span',[_vm._v(_vm._s(_vm.text)+" ")]),_c('v-icon',{attrs:{"size":"16"}},[_vm._v("arrow_forward")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }